import { h } from "hyperapp";

export const addressRenderer = ({ address }) => {
  const text = [
    [address.street, address.number || "S/N", address.neighborhood]
      .filter(v => !!v)
      .join(", "),
    address.city,
    address.state,
    address.country,
    address.zipcode,
  ]
    .filter(v => !!v)
    .join(" - ")
    .trim()
    .replace(/^S\/N$/g, "");
  return (
    <span data-placement="left" title={text}>
      {text}
    </span>
  );
};
